import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
if (environment.oneAPMId){
	window["oneAPMId"] = environment.oneAPMId;
}
if (environment.oneAPMId){
	window["transBaseUrl"] = environment.transBaseUrl;
}
if(environment.version){
  window["version"] = environment.version;
}
if(environment.appName){
  window["appId"] = environment.appId;
}
if(environment.appName){
  window["appName"] = environment.appName;
}
// if(environment.companyList){
//   window["companyList"] = environment.companyList;
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts